// extracted by mini-css-extract-plugin
module.exports =  {"collapsableHeader":"collapsableHeader___14epu","headerHeader":"headerHeader___ZMGeC","image":"image___2Li0V","headerText":"headerText___J8v7M","collapsed":"collapsed___-9gAa"};